import { SET_INITIAL_URL } from '../modules/url/actions'
import { receivedWhitelistedProperties } from '../modules/properties/actions'
import { firestore } from '../utils/firebase'

export default store => next => action => {
  switch (action.type) {
    case SET_INITIAL_URL:
      fetchWhiteListedProperties(store)
      next(action)
      break

    default:
      next(action)
  }
}

function fetchWhiteListedProperties (store) {
  firestore
    .collection('property_settings')
    .doc('whitelisted')
    .onSnapshot(doc =>
      store.dispatch(receivedWhitelistedProperties(
        doc.exists
          ? doc.data()
          : {}
      ))
    )
}
